// Avatar/Farb-Helper – EINE zentrale Stelle für „Farbe eines Monteurs“ (A-027 S2)
//   1. Ist der Monteur mit einem Mitarbeiter verknüpft und hat der eine Farbe (Mitarbeiter-Seite), gilt diese.
//   2. Sonst (Rückfall) eine Farbe aus dem Namen (Hash), wie bisher.
// Die Farben der Verknüpften kommen vom Server (GET /mitarbeiter-farben) und werden mit ladeMonteurFarben() geholt.
// Die 12 Farben sind dieselben wie in backend/utils/monteur_farben.py.
// Wird genutzt von:
//   - /pages/termine/ModuleTerminePage.jsx, TerminKalender.jsx
//   - /pages/aufgaben/ModuleAufgabenPage.jsx
//   - /pages/EinsaetzeModulPage.jsx, /pages/MitarbeiterModulPage.jsx
import { api } from "@/lib/api";

// bg/border als feste Klassen (Tailwind), hex = derselbe Farbwert für den Kalender
export const AVATAR_PALETTE = [
  { bg: "bg-blue-500", border: "border-blue-500", hex: "#3b82f6", name: "Blau" },
  { bg: "bg-emerald-500", border: "border-emerald-500", hex: "#10b981", name: "Grün" },
  { bg: "bg-amber-500", border: "border-amber-500", hex: "#f59e0b", name: "Gelb" },
  { bg: "bg-rose-500", border: "border-rose-500", hex: "#f43f5e", name: "Rot" },
  { bg: "bg-violet-500", border: "border-violet-500", hex: "#8b5cf6", name: "Violett" },
  { bg: "bg-cyan-500", border: "border-cyan-500", hex: "#06b6d4", name: "Türkis" },
  { bg: "bg-orange-500", border: "border-orange-500", hex: "#f97316", name: "Orange" },
  { bg: "bg-lime-600", border: "border-lime-600", hex: "#65a30d", name: "Hellgrün" },
  { bg: "bg-pink-500", border: "border-pink-500", hex: "#ec4899", name: "Rosa" },
  { bg: "bg-slate-600", border: "border-slate-600", hex: "#475569", name: "Grau" },
  { bg: "bg-fuchsia-600", border: "border-fuchsia-600", hex: "#c026d3", name: "Magenta" },
  { bg: "bg-yellow-700", border: "border-yellow-700", hex: "#a16207", name: "Braun" },
];

// Farben der verknüpften Mitarbeiter: Anmeldename -> Farbwert (vom Server)
let farbKarte = {};
// Namen: Anmeldename -> „Vorname Nachname“ (aus den Benutzern). Überall, wo ein Monteur angezeigt wird, monteurName() nehmen.
let nameKarte = {};
let geladen = null;

/** Einmal laden (merkt sich die Antwort); mit neu=true nach Änderungen erneut holen. Holt Farben UND Namen. */
export const ladeMonteurFarben = (neu = false) => {
  if (!geladen || neu) {
    geladen = Promise.all([
      api.get("/mitarbeiter-farben").then((r) => { farbKarte = r.data && typeof r.data === "object" ? r.data : {}; }).catch(() => {}),
      api.get("/module-aufgaben/mitarbeiter").then((r) => {
        const neu_ = {};
        (Array.isArray(r.data) ? r.data : []).forEach((m) => { if (m.username) neu_[m.username] = m.anzeige_name || m.username; });
        nameKarte = neu_;
      }).catch(() => {}),
    ]).then(() => farbKarte);
  }
  return geladen;
};

/** Name eines Monteurs zum Anzeigen („Marco Schreiner“); ist er nicht bekannt, bleibt der Anmeldename. */
export const monteurName = (username) => (username ? (nameKarte[username] || username) : "");

const hashFarbe = (username) => {
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = (hash * 31 + username.charCodeAt(i)) >>> 0;
  }
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
};

export const colorForUser = (username) => {
  if (!username) return null;
  const hex = farbKarte[username];
  const treffer = hex && AVATAR_PALETTE.find((p) => p.hex.toLowerCase() === String(hex).toLowerCase());
  return treffer || hashFarbe(username);
};

export const initialsOf = (username) => {
  if (!username) return "?";
  const parts = username.split(/[._\s-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.slice(0, 2) || "?").toUpperCase();
};

export const MonteurAvatar = ({ username, size = "sm", title }) => {
  const c = colorForUser(username);
  if (!c) return null;
  const sizeCls = size === "lg" ? "w-9 h-9 text-sm" : "w-6 h-6 text-[10px]";
  return (
    <div
      className={`${sizeCls} rounded-full ${c.bg} text-white font-bold flex items-center justify-center flex-shrink-0 select-none`}
      title={title || username}
    >
      {initialsOf(username)}
    </div>
  );
};
